const initialState = {
    data: [],
  };
  
  const serwisReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_SERWIS':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default serwisReducer;